export default "__VITE_ASSET__BBIYkfPG__"